<template>
  <div class="compressed-content">
    <h3>Has your healthcare provider diagnosed your Type 2 Diabetes as being in remissions (A1C below 6.4% and not on glucose-lowering medication)?</h3>
    <v-form-group class="card-selector page-buttons">
      <b-form-radio v-model="survey.bloodSugar.diabetesHistory.hadType2Remission" name="hadType2Remission"
                    :value="true">Yes</b-form-radio>
      <b-form-radio v-model="survey.bloodSugar.diabetesHistory.hadType2Remission" name="hadType2Remission"
                    :value="false">No</b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  export default {
    mixins: [formMixin],


    computed: {
      ...mapState(["survey"]),

      hadDiabetesType2() { return this.survey.bloodSugar.diabetesHistory.hadType2Remission; }
    }
  };
</script>